import styles from './A_CheckboxItem.module.css';
import cn from 'classnames';

interface A_CheckboxItemProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  children?: React.ReactNode;
}

export default function A_CheckboxItem({
  checked = false,
  onChange,
  children,
}: A_CheckboxItemProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <div className={styles.wrapper}>
      <input type='checkbox' checked={checked} onChange={handleChange} />
      <label className={cn(styles.label, 'text-p-6')}>{children}</label>
    </div>
  );
}
